module.exports = __webpack_public_path__ + "static/media/alarmClock.de73f968.wav";